'use strict';
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var cast_1 = require("./cast");
var Calc;
(function (Calc) {
    function percent(value, percent) {
        return cast_1.Cast.toNumber(value) * (1 + cast_1.Cast.toNumber(percent) / 100);
    }
    Calc.percent = percent;
    function sum() {
        var numbers = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            numbers[_i] = arguments[_i];
        }
        return numbers.reduce(function (previousValue, currentValue) { return previousValue + currentValue; });
    }
    Calc.sum = sum;
    function average() {
        var numbers = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            numbers[_i] = arguments[_i];
        }
        return sum.apply(void 0, __spread(numbers)) / numbers.length;
    }
    Calc.average = average;
    function coefficient(value, coefficient, invert) {
        if (invert === void 0) { invert = false; }
        coefficient = cast_1.Cast.toNumber(coefficient);
        if (coefficient === 0) {
            return 0;
        }
        coefficient = Math.abs(coefficient);
        value = cast_1.Cast.toNumber(value);
        if (coefficient === 1) {
            return value;
        }
        return invert ? (coefficient > 1 ? value * coefficient : value / coefficient) : value * coefficient;
    }
    Calc.coefficient = coefficient;
    function toFixed(value, floatPrecision) {
        if (floatPrecision === void 0) { floatPrecision = -1; }
        if (floatPrecision === 0) {
            return cast_1.Cast.toInteger(value);
        }
        if (floatPrecision > 0) {
            return Number.parseFloat(value.toFixed(cast_1.Cast.toInteger(floatPrecision)));
        }
        return value;
    }
    Calc.toFixed = toFixed;
})(Calc = exports.Calc || (exports.Calc = {}));



//////////////////
// WEBPACK FOOTER
// ./src/typescripts/shared/utils/calc.ts
// module id = 22
// module chunks = 0 1